import React from 'react';
import PMarkManagement from './PMarkManagement';
import ActiveReviewManagement from './ActiveReviewManagement';

const ReviewManagement = ({ subTab, searchParams, updateURL, onCountsChange }) => {
  switch (subTab) {
    case 'p-mark':
      return (
        <PMarkManagement
          searchParams={searchParams}
          updateURL={updateURL}
          onCountsChange={onCountsChange}
        />
      );
    case 'active-review':
      return (
        <ActiveReviewManagement
          searchParams={searchParams}
          updateURL={updateURL}
          onCountsChange={onCountsChange}
        />
      );
    default:
      return null;
  }
};

export default ReviewManagement;
